import { PropsWithChildren } from 'react'
import './loaderIcon.css'
export default function LoaderIcon ({children}: PropsWithChildren){
return (        
    <div className="loader">
        <div className="loader-wheel"></div>
        <div className="loader-text"></div>
        <div><strong>{children}</strong></div>
    </div>)
}